<aside class="ldn-menu">
    <div class="user-info">
        <ldn-user-account-menu></ldn-user-account-menu>
    </div>
    <div class="menu-buttons">
        <i class="fas fa-message ldn-button ldn-button--link notification-hub-status"
           [ngClass]="{'notification-hub-status--pending': (notificationHubState | async) === 2, 'notification-hub-status--connected': (notificationHubState | async) === 1}"
           (click)="toggleNotificationHub()"
           title="Powiadomienia"></i>
        <i class="fas fa-thumbtack ldn-button ldn-button--link" (click)="changeMenuState()"
           title="Przypnij/Odepnij"></i>
    </div>
    <div class="ldn-menu__content">
        <a *ngIf="!production && !acceptance" routerLink="dashboard" routerLinkActive="active">Dashboard</a>
        <a routerLink="filtry" routerLinkActive="active">Filtry</a>
        <a routerLink="filtry/publiczne" routerLinkActive="active" class="sub-menu">Publiczne</a>
        <a routerLink="filtry/prywatne" routerLinkActive="active" class="sub-menu">Prywatne</a>
        <a routerLink="filtry/udostepnione" routerLinkActive="active" class="sub-menu">Udostępnione</a>
        <a routerLink="akty" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Akt)">Akty</a>
        <a routerLink="akty/wersje" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.WersjeAktow)" class="sub-menu">Wersje</a>
        <a routerLink="pismaUrzedowe" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.PismoUrzedowe)">Pisma urzędowe</a>
        <a routerLink="listyKontrolne" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.ListaKontrolna)">Listy kontrolne</a>
        <a routerLink="listyKontrolne/kategorie" routerLinkActive="active" class="sub-menu">Kategorie</a>
        <a routerLink="orzeczenia" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Orzeczenie)">Orzeczenia</a>
        <a routerLink="orzeczenia/tezy" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.TezaOrzeczen)" class="sub-menu">Tezy</a>
        <a routerLink="orzeczenia/uzasadnienia" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.UzasadnienieOrzeczen)" class="sub-menu">Uzasadnienia</a>
        <a routerLink="orzeczenia/tytuly" routerLinkActive="active" class="sub-menu">Tytuły orzeczeń</a>
        <a routerLink="orzeczenia/orzeczeniaImportowe" routerLinkActive="active" class="sub-menu"
           (click)="clearObiektListState(ListDefinitionType.OrzeczenieImportowe)">Orzeczenia do importu</a>
        <a routerLink="orzeczenia/wydawnictwaImportowe" routerLinkActive="active" class="sub-menu">Wydawnictwa
            importowe</a>
        <a routerLink="publikacje" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Publikacja)">Publikacje</a>
        <a routerLink="publikacje/tezy" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.TezyPublikacji)" class="sub-menu">Tezy</a>
        <a routerLink="szkolenia" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Szkolenie)">Szkolenia</a>
        <a routerLink="wzory" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Wzor)">Wzory</a>
        <a routerLink="wzory/objasnienia" routerLinkActive="active" class="sub-menu">Objaśnienia</a>
        <a routerLink="grafiki" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Grafika)">Grafiki</a>
        <a routerLink="formularzeDocumento" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.FormularzDocumento)">Formularze Documento</a>
        <a routerLink="pytaniaOdpowiedzi" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.PytanieOdpowiedz)">Pytania i odpowiedzi</a>
        <a routerLink="procedury" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Procedura)">Procedury</a>
        <a routerLink="analizy" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.Analiza)">Analizy</a>
        <a routerLink="wazneTerminy" routerLinkActive="active"
           (click)="clearObiektListState(ListDefinitionType.WaznyTermin)">Ważne terminy</a>
        <a *ngIf="!production && !acceptance" routerLink="demo" routerLinkActive="active">Demo</a>
        <a (click)="openHealthCheck()" target="_blank">Nadzorca</a>
    </div>
    <div class="ldn-menu__version">{{ version }}</div>
</aside>
<div class="content-wrapper"
     [ngClass]="{'ldn-preview--hidden': !currentPreviewVisibility,
     'ldn-preview--vertical': currentPreviewVisibility && currentPreviewStatus === 2,
     'ldn-preview--horizontal': currentPreviewVisibility && currentPreviewStatus === 3}">
    <main>
        <router-outlet></router-outlet>
    </main>
    <ldn-preview-container class="ldn-preview" (show)="showPreview()" (switch)="switchPreview()"
                           (close)="closePreview()"></ldn-preview-container>
</div>
<p-toast key="cerber" position="bottom-center" [baseZIndex]="999999">
    <ng-template let-message pTemplate="message">
        <div class="p-toast-message-content ldn-toast-message">
            <div class="ldn-toast-message-content">
                <span class="p-message-icon pi pi-info-circle ng-star-inserted"></span>
                <div class="p-toast-message-text">
                    <div class="p-toast-summary">{{ message.summary }}</div>
                    <div class="p-toast-detail">{{ message.detail }}</div>
                </div>
                <button class="p-toast-icon-close p-link p-ripple ng-star-inserted"
                        type="button"
                        (click)="onCerberMessageClose()">
                    <span class="p-toast-icon-close-icon pi pi-times"></span>
                    <span class="p-ink" style="height: 28px; width: 28px; top: 1px; left: -3.5px;"></span>
                </button>
            </div>
            <div class="ldn-toast-button">
                <button class="p-button-secondary p-button"
                        type="button"
                        style=""
                        (click)="onCerberMessageClick()">OK
                </button>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast key="common" [baseZIndex]="999999"></p-toast>
<ldn-window-container></ldn-window-container>
<ldn-notification-hub [(visible)]="notificationHubVisible"></ldn-notification-hub>
<i *ngIf="loading()" class="fas fa-spin fa-circle-notch ldn-app__loader"></i>